import React from 'react';
import DashboardContext, {
  Provider as DashboardContextProvider
} from './../../contexts/DashboardContext';
import UserContext from '../../contexts/UserContext';
import AppDrawer from '../../components/AppDrawer';
import Button from '../../components/Button';
import Splasher from '../../components/Splasher';
import { withStyles } from '@material-ui/core/styles';
import Routes from './Routes';
import DrawerContent from './Drawer';
import { navigate } from '@reach/router';
import config from '../../config';
import PeriodSelector from '../../components/PeriodSelector';
import get from 'lodash/get';
import PrivateBlock from '../../components/PrivateBlock';
const styles = () => ({
  rightBtns: {
    float: 'right',
    '& > *': {
      marginLeft: 10
    }
  }
});

function WeekNotifier() {
  return (
    <PrivateBlock allowedGroups={['Admins']}>
      <Button
        onClick={() => {
          navigate('/settings/weeks?create=true');
        }}
        color="secondary">
        Create Week
      </Button>
    </PrivateBlock>
  );
}

const Body = withStyles(styles)(props => {
  const { classes } = props;
  const { service, state } = React.useContext(DashboardContext);
  const { currentUser, signOut, error } = React.useContext(UserContext);
  const handleSignOut = () => {
    signOut({ path: window.location.pathname, userId: currentUser.username });
    if (error) {
      console.log('Error on sign out: ', error);
    } else {
      navigate('/');
    }
  };
  const handlePeriodChange = React.useCallback(
    period => {
      service.send({ type: 'CHANGE_PERIOD', value: period });
    },
    [service]
  );
  console.log('get(state', get(state, 'context.currentPeriod.id')); //TRACE
  return (
    <>
      {state.matches('initializing') && <Splasher />}
      {state.matches('showContent') && (
        <AppDrawer
          footerLogoUrl={config.logoUrl}
          headerContent={
            <div className={classes.rightBtns}>
              <PeriodSelector
                defaultLatest
                value={get(state, 'context.currentPeriod.id')}
                onChange={handlePeriodChange}
                asButton
              />
              <WeekNotifier />
              <Button onClick={handleSignOut} color="primary">
                Log out
              </Button>
            </div>
          }
          drawerContent={<DrawerContent />}>
          <Routes />
        </AppDrawer>
      )}
    </>
  );
});

const DashboardPage = () => (
  <DashboardContextProvider>
    <Body />
  </DashboardContextProvider>
);

export default DashboardPage;
